import { SolicitacaAPI } from "@/api/solicitacao.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import Solicitacao from "@/models/solicitacao";

const solicitacaoApi = new SolicitacaAPI();

const solicitacaoAreas = (): AxiosObservable<any> => {
  return solicitacaoApi.solicitacaoAreas();
};

const solicitacaoTipos = (): AxiosObservable<any> => {
  return solicitacaoApi.solicitacaoTipos();
};

const solicitacaoFormasContato = (): AxiosObservable<any> => {
  return solicitacaoApi.solicitacaoFormaContato();
};

const create = (body: Solicitacao): AxiosObservable<Solicitacao> =>
  solicitacaoApi.create(body);

const solicitaFindByIdAndEmail = (
  id: number,
  email: string,
  recaptcha: string
): AxiosObservable<Solicitacao> =>
  solicitacaoApi.solicitacaoFindByIdAndEmail(id, email, recaptcha);

export default {
  solicitacaoAreas,
  solicitacaoTipos,
  solicitacaoFormasContato,
  solicitaFindByIdAndEmail,
  create
};
